







import { Vue, Component, Prop } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component({
  name: 'EntityLink',
})
export default class EntityLink extends Vue {
  @Prop({ type: [String, Number], required: true })
  label!: number | string;

  @Prop({ type: Boolean, required: false })
  active!: boolean | undefined;

  @Prop({ required: false })
  location!: string | RawLocation | undefined;
}
